/**
 *
 * Centralize initial state for the app
 *
 * Created by stephen on 5/15/17.
 */
export default{
  // authors: []
  // , projects: []
  // , grids: [],
   ajaxCallsInProgress: 0
}


// WEBPACK FOOTER //
// ./src/reducers/initialState.js